package com.example.mystybag.core.expected

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
actual fun rememberIsWebPortraitLayout(): Boolean {
    var portrait by remember {
        mutableStateOf(window.innerWidth < window.innerHeight)
    }
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            portrait = window.innerWidth < window.innerHeight
        }
        window.addEventListener("resize", listener)
        window.addEventListener("orientationchange", listener)
        onDispose {
            window.removeEventListener("resize", listener)
            window.removeEventListener("orientationchange", listener)
        }
    }
    return portrait
}
